import React, {useState, useCallback} from 'react';
import EffectParameterSlider from '../EffectParameterSlider.js';
import SubMacroEditor from './SubMacroEditor.js';
import '../../../Macros.scss';

export default ({macro, sequencerEngine}) => {
    const [macroName, setMacroName] = useState(macro.name);
    let {subMacros} = macro;

    const onChangeName = useCallback((e) => {
        macro.name = e.target.value;
        setMacroName(macro.name);
    }, [setMacroName]);

    return (
        <div className="macro-details">
          <input
            type="text"
            className="name-editor"
            value={macroName}
            onChange={onChangeName}
            placeholder="Enter macro's name"
          >
          </input>
          <EffectParameterSlider
            effectNumber={0}
            automation={undefined}
            name={macro.name}
            selectedParameter={undefined}
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            parameter={macro.macroParameter}
            isParameter={true}
            onParameterChanged={() => []}
            step={0.01}
            max={1}
            min={0}
            />
        {subMacros.map(
            subMacro =>
                <SubMacroEditor
                  macro={macro}
                  subMacro={subMacro}
                />)}
        </div>
    );
};
